import * as React from 'react';
import * as ReactDOM from 'react-dom';

var AppContainer =
/** @class */
function () {
  /**
   * Create a new App Container instance for the given Root component and Handler
   *
   * `handler` can be either a class or a Handler instance itself
   *
   * @param {ClassArg<H extends ActionHandlerInterface<R>> | H} handler
   */
  function AppContainer(handler) {
    this._actionHandler = typeof handler === 'function' ? new handler() : handler;
  }

  Object.defineProperty(AppContainer.prototype, "root", {
    /**
     * Return the root application object
     *
     * @return {R}
     */
    get: function get() {
      if (!this._root) {
        throw new ReferenceError('Root element is not assigned yet');
      }

      return this._root;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AppContainer.prototype, "actionHandler", {
    /**
     * Return the Action Handler instance
     *
     * @return {H}
     */
    get: function get() {
      return this._actionHandler;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Render the main application
   *
   * @param rootClass
   * @param {Element} container
   * @param {PropsType<R extends React.Component> | null} props
   */

  AppContainer.prototype.render = function (rootClass, container, props) {
    var _this = this;

    var initializationProps = props;
    var rootElement;

    var attachRenderedInstanceToRoot = function attachRenderedInstanceToRoot(renderedElement) {
      rootElement = renderedElement;
    };

    if (initializationProps) {
      initializationProps.ref = attachRenderedInstanceToRoot;
    } else {
      initializationProps = {
        ref: attachRenderedInstanceToRoot
      };
    }

    var afterRenderCallback = function afterRenderCallback() {
      if (rootElement) {
        _this.initialize(rootElement);
      }
    };

    var element = React.createElement(rootClass, initializationProps, null);

    if (this._renderer) {
      this._renderer.render(element, container, afterRenderCallback);
    } else {
      ReactDOM.render(element, container, afterRenderCallback);
    }
  };
  /**
   * Specify a different renderer implementation (e.g. for testing)
   *
   * @param {RendererInterface<R extends React.Component>} renderer
   */


  AppContainer.prototype.setRenderer = function (renderer) {
    this._renderer = renderer;
  };
  /**
   * Initialize the Action Handler instance
   *
   * @param {R} root
   */


  AppContainer.prototype.initialize = function (root) {
    this._root = root;

    this._actionHandler.registerRoot(root);
  };

  return AppContainer;
}();

export { AppContainer };